import {createElement} from 'rlink-react';
import {jsonp} from 'rlink-utils/xhr';
import ShopProvider from 'rlink-shop/service/base';

export class HumbleBundleService extends ShopProvider {
  constructor () {
    super();
    this.apiEndPoint = 'https://www.humblebundle.com/public_api/v1/product/';
  }

  apiRequest (options) {
    options = options || {};
    options.url = this.apiEndPoint + options.path + '_storefront';
    options.data = options.data || {};

    return jsonp('callback', options.url, options.data);
  }

  _getPrice (humbleBundleId) {
    let options = {
      path: humbleBundleId,
    };

    return this.apiRequest(options).then(responseRaw => {
      let response = responseRaw.text;
      if (response.error !== undefined) {
        throw {
          error: response.error,
          message: response.message,
        };
      } else {
        let data = {
          normalPrice: response["local_original_pricing"],
          salePrice: response["local_pricing"]
        };

        return data;
      }
    }).catch(error => {
      if (error === undefined) {
        error = {};
      }
      if (error.error === undefined) {
        error.error = 'SERVER_ERROR';
      }
      throw error;
    });
  }

  getMoreInfoHref (product) {
    if ('body' in product) {
      return {
        view: 'buy',
        params: {slug: product.slug},
        keepScrollPosition: true,
      };
    }
    return '';
  }

  getPurchaseHref (data) {
    return {
      view: 'buy',
      content: data.purchaseModalContent,
      modal: true,
    };
  }

  _getModalContent (identifier, size) {
    return (<iframe src={`https://www.humblebundle.com/widget/v2/product/${identifier}?theme=dark`} width={size.width} height={size.height} scrolling="no" frameBorder="0"></iframe>);
  }
}



// WEBPACK FOOTER //
// ./lib/rlink-shop/service/humble-bundle.jsx